import type {RouteLocationRaw, RouteRecordRaw} from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getConfirmAccountRouteRecord():RouteRecordRaw{
  return {
    name: 'confirm_account',
    path: '/confirm-account',
    component: customAsyncComponent(() => import('./views/ConfirmAccountView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.CONFIRM_ACCOUNT,
      ]
    },
  }
}

export function getConfirmAccountRouteLocation():RouteLocationRaw{
  return { name: 'confirm_account' }
}